import React from 'react'
import { Input } from '@driftt/tide-core-legacy'

const selectAll = (bulkSelect) => (bulkSelect())

export const userTitle = (user) => user.name || user.alias || ''

export const FuseOptions = {
  keys: ["name", "email"],
  caseSensitive: false,
  includeScore: false,
  shouldSort: true,
  tokenize: false,
  threshold: 0.2,
  location: 0,
  distance: 100,
}

export const AddTeamMembersColumns = ({ bulkSelect, onUserSort }) => ([
  {
    label: selectAll(bulkSelect),
    sortable: false,
    value: 'selected',
    width: '50px'
  },
  {
    label: 'Teammates',
    sortable: false,
    value: 'user.name',
    width: '200px',
  },
  {
    label: 'Role',
    value: 'user.type',
    width: '75px'
  }
])


// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/MemberSelectorTable/constants.js